const Types = {
  GET_OFFICE_HOURS_REQUEST: "GET_OFFICE_HOURS_REQUEST",
  GET_OFFICE_HOURS_SUCCESS: "GET_OFFICE_HOURS_SUCCESS",
  GET_OFFICE_HOURS_FAIL: "GET_OFFICE_HOURS_FAIL",

  CREATE_OFFICE_HOUR_REQUEST: "CREATE_OFFICE_HOUR_REQUEST",
  CREATE_OFFICE_HOUR_SUCCESS: "CREATE_OFFICE_HOUR_SUCCESS",
  CREATE_OFFICE_HOUR_FAIL: "CREATE_OFFICE_HOUR_FAIL",

  UPDATE_OFFICE_HOUR_REQUEST: "UPDATE_OFFICE_HOUR_REQUEST",
  UPDATE_OFFICE_HOUR_SUCCESS: "UPDATE_OFFICE_HOUR_SUCCESS",
  UPDATE_OFFICE_HOUR_FAIL: "UPDATE_OFFICE_HOUR_FAIL",

  DELETE_OFFICE_HOUR_REQUEST: "DELETE_OFFICE_HOUR_REQUEST",
  DELETE_OFFICE_HOUR_SUCCESS: "DELETE_OFFICE_HOUR_SUCCESS",
  DELETE_OFFICE_HOUR_FAIL: "DELETE_OFFICE_HOUR_FAIL",

  CANCEL_OFFICE_HOUR_REQUEST: "CANCEL_OFFICE_HOUR_REQUEST",
  CANCEL_OFFICE_HOUR_SUCCESS: "CANCEL_OFFICE_HOUR_SUCCESS",
  CANCEL_OFFICE_HOUR_FAIL: "CANCEL_OFFICE_HOUR_FAIL",

  OFFICE_HOURS_LOADING: "OFFICE_HOURS_LOADING",
};

export default Types;
